import React from 'react';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';

const HelmetHead = (props) => {
  const { extraHead = '' } = props;

  return <Helmet>{extraHead && parse(extraHead)}</Helmet>;
};

export default HelmetHead;
